import { render, staticRenderFns } from "./voice_chat_view.vue?vue&type=template&id=597f9db3&scoped=true"
import script from "./voice_chat_view.vue?vue&type=script&lang=js"
export * from "./voice_chat_view.vue?vue&type=script&lang=js"
import style0 from "./voice_chat_view.vue?vue&type=style&index=0&id=597f9db3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597f9db3",
  null
  
)

export default component.exports